@if (isSpinnerVisible) {
<div class="preloader-backdrop global-loader">
  <div>
    <div class="loader"></div>
  </div>
</div>
}
